import BaseBrowserStore from './base/base-browser-store'

class SessionStore extends BaseBrowserStore {
    constructor (session = {}) {
        super('session')
    }

    async getAccessToken () {
        return await this.get('access_token')
    }

    async setAccessToken (token) {
        await this.set('access_token', token)
    }

    async removeAccessToken () {
        await this.remove('access_token')
    }

    /**
     * `account_role` for the currently-authenticated user (e.g. `'user'` or
     * `'admin'`). Populated lazily by `useAdminGuard` from the `GET /user`
     * response (plan §1.7b — collapses the legacy `newsroom-admin-session-store`
     * into the main store).
     *
     * Returns `null` / `undefined` when no role has been cached yet; consumers
     * treat that as "fetch needed" and avoid relying on it for security gates
     * (the API enforces `fastify.requireRole('admin')` per request).
     */
    async getRole () {
        return await this.get('role')
    }

    async setRole (role) {
        await this.set('role', role)
    }

    async removeRole () {
        await this.remove('role')
    }

    async clear () {
        await this.removeAccessToken()
        await this.removeRole()
    }
}

const sessionStore = new SessionStore()
export default sessionStore
